export default __webpack_public_path__ + "static/optic-visions-9b2a3dcda05e27f2d5d537945adfc962.png";